module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-01.c28fa30c.png";